import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stack,
  TextField,
  InputAdornment,
} from "@mui/material";

import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import IconButton from "@mui/material/IconButton";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import CustomButton from "../components/CustomButton";
import TopBar from "../components/TopBar";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";

const API_URL = process.env.REACT_APP_API_URL

const CreateEventPage = () => {
  const navigate = useNavigate();
  const [eventName, setEventName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [eventDate, setEventDate] = useState("");
  const [user, setUser] = useState({});
  const [minAmount, setMinAmount] = useState("5");
  const [paymentsAllowed, setPaymentsAllowed] = useState(true);



  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
      } else {
        setUser(currentUser)
        navigate('/Login')
      }
    })

    return () => unsubscribe()
  }, [])


  const handleFileInputChange = (e) => {
    // Define the logic for handling file input change
  };

  const handleClearClick = () => {
    setSelectedFile("");
  };

  const clearInput = (inputField) => {
    setEventName("");
  };

  const createEvent = () => {
    if(user && user.email) {
      fetch(`${API_URL}/firebase/create-event`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userEmail: user.email,
          eventName: eventName,
          eventDate: eventDate,
          minimumAmount: minAmount,
          paymentsAllowed: paymentsAllowed
        })
      }).then((res) => res.json())
      .then((res) => {
        navigate(`/Events/${res.newEventId}`)
      })
    }
  }

  return (
    <Box className="max_container" sx = {{ marginTop: 8 }}>
      <TopBar />
      <Box className="mt-10">
        <TextField
          id="input-with-icon-textfield"
          label="Event Name"
          placeholder="input"
          fullWidth
          value={eventName}
          onChange={(e) => setEventName(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <DriveFileRenameOutlineOutlinedIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <HighlightOffIcon
                  onClick={() => clearInput("eventName")}
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </Box>
      <Box className="mt-5 flex-container" />
				{
					paymentsAllowed 
					? 
					<p className="text-switch">Payments are enabled. You can change this later in event settings</p>
					:
					<p className="text-switch">Payments are disabled. You can change this later in event settings</p>
				}
				<label className="switch">
					<input
						type="checkbox"
						checked={paymentsAllowed}
						onChange={() => setPaymentsAllowed(!paymentsAllowed)}
					/>
					<span className="slider" />
				</label>
			<Box/>
      <Stack className="bg-gray-500 px-6 mt-8 py-8 rounded-[10px]">
        <p className="text-[#CAC4D0]">Select Date</p>

        <Box className="mt-5">
          <TextField
            id="input-with-icon-textfield"
            label="Date"
            type="date"
            fullWidth
            variant="outlined"
            value={eventDate}
            onChange={(e) => setEventDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Stack>
      <Box className="mt-5">
        <TextField
          id="input-with-icon-textfield"
          label="Minimum Tip Amount"
          type="number"
          placeholder="input"
          fullWidth
          value={minAmount}
          onChange={(e) => setMinAmount(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AttachMoneyOutlinedIcon />
              </InputAdornment>
            )
            
          }}
          variant="outlined"
        />
      </Box>
      <Box className="mt-10">
        <TextField
          id="input-file-textfield"
          label="Insert Picture (optional)"
          type="file"
          accept=".png, .jpg"
          fullWidth
          variant="outlined"
          value={selectedFile}
          onChange={(e) => setSelectedFile(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            inputProps: {
              accept: ".pdf,.doc,.docx,.png,.jpg",
            },
            startAdornment: (
              <IconButton component="label">
                <AttachFileIcon style={{ color: "white" }} />
                <input
                  type="file"
                  accept=".png, .jpg"
                  style={{ display: "none" }}
                  onChange={handleFileInputChange}
                />
              </IconButton>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {selectedFile && (
                  <IconButton onClick={handleClearClick}>
                    <HighlightOffIcon
                      style={{ color: "white" }}
                      className="text-white"
                    />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box className="mt-10 px-12">
        <CustomButton 
          myFunction={createEvent}
          text={"Create Event"}
        />
      </Box>
    </Box>
  );
};

export default CreateEventPage;
